import { Component } from '@angular/core';

@Component({
  selector: 'skeleton-insignias',
  templateUrl: 'skeleton-insignias.html'
})
export class SkeletonInsigniasComponent {

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/skeleton-insignias/skeleton-insignias.ts